import React from 'react';

export default function ShareSvgIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" fill="none" viewBox="0 0 16 20">
      <path
        fill="#000"
        d="M1.5 12v6.5h12.999V12h1.5v6.5a1.5 1.5 0 0 1-1.5 1.5H1.5A1.5 1.5 0 0 1 0 18.5V12h1.5zM7.998 0L14.5 6.498l-1.06 1.061-4.69-4.689v11.275h-1.5V2.87L2.564 7.556l-1.06-1.061L7.997 0z"
      />
    </svg>
  );
}
